export enum ConfigurationType
{
    None = 0,
    Date = 1,
    Weekly = 2,
    Monthly = 3,
}